<template>
  <div class="dv-unsupported">
    <span class="dv-unsupported__icon" :class="`fiv-viv fiv-icon-${extension || 'blank'}`" aria-hidden="true"></span>
    <div class="dv-unsupported__name">{{ document.fileName || document.documentNumber || 'Document' }}</div>
    <div v-if="document.size" class="dv-unsupported__meta">{{ $formatFileSize(document.size, 1) }}</div>
    <p class="dv-unsupported__text">{{ message }}</p>
    <v-btn small depressed color="primary" @click="$emit('download')">
      <v-icon small left>mdi-download</v-icon>
      Download
    </v-btn>
  </div>
</template>

<script>
  import { documentExtension } from '../documentKinds';

  /** The card for files nothing in the browser can show. Renderer contract: see DocumentViewerShell. */
  export default {
    name: 'UnsupportedRenderer',
    props: {
      document: { type: Object, required: true },
    },
    computed: {
      extension() {
        return documentExtension(this.document);
      },
      message() {
        if (this.extension === 'tif' || this.extension === 'tiff') {
          return 'TIFF images cannot be shown in this browser. Download the file to open it.';
        }
        return this.extension
          ? `.${this.extension.toUpperCase()} files cannot be previewed here. Download the file to open it.`
          : 'This file cannot be previewed here. Download it to open it.';
      },
    },
    mounted() {
      this.$emit('ready');
    },
    methods: {
      command() {},
    },
  };
</script>

<style lang="scss" scoped>
  .dv-unsupported {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    height: 100%;
    padding: 24px;
    text-align: center;
  }

  .dv-unsupported__icon {
    font-size: 56px;
    margin-bottom: 4px;
  }

  .dv-unsupported__name {
    font-weight: 600;
    max-width: 420px;
    word-break: break-word;
  }

  .dv-unsupported__meta {
    font-size: var(--ds-font-caption, 12px);
    opacity: 0.7;
  }

  .dv-unsupported__text {
    max-width: 420px;
    margin: 4px 0 8px;
    opacity: 0.8;
  }
</style>
